// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","container":"container-OxMvI","title":"title-HqOPX","icon":"icon-VMp1I","text":"text-taBo1","image":"image-1BUfB"};